export function EditGlyph({ large = false }: { large?: boolean }) {
  return (
    <span
      className={`modern-edit-glyph${large ? ' modern-edit-glyph-large' : ''}`}
      aria-hidden="true"
    >
      <img src="../editbutton.png" alt="" />
    </span>
  );
}
